// extracted by mini-css-extract-plugin
export default {"productCarousel":"q5-z"};